import { inject, Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../environments/environment.js';
import { DomSanitizer } from '@angular/platform-browser';
import { BlockchainId } from '@gains-com/shared';

@Pipe({
  name: 'blockchainUrl',
})
export class BlockchainUrlPipe implements PipeTransform {
  private readonly _sanitizer = inject(DomSanitizer);

  transform(address: string, blockchain: BlockchainId, type: 'tx' | 'address') {
    const { blockchainTestnet } = environment;

    let url: string;

    switch (blockchain) {
      case BlockchainId.Solana:
        url = `https://explorer.solana.com/${type}/${address}${
          blockchainTestnet ? '?cluster=devnet' : ''
        }`;
        break;
      case BlockchainId.Ethereum:
        url = `https://${
          blockchainTestnet ? 'sepolia.' : ''
        }etherscan.io/${type}/${address}`;
        break;
      case BlockchainId.Polygon:
        url = `https://${
          blockchainTestnet ? 'amoy.' : ''
        }polygonscan.com/${type}/${address}`;
        break;
      case BlockchainId.Bitcoin:
        url = `https://blockstream.info${
          blockchainTestnet ? '/testnet' : ''
        }/${type}/${address}`;
        break;
      case BlockchainId.Arbitrum:
        url = `https://${
          blockchainTestnet ? 'sepolia.' : ''
        }arbiscan.io/${type}/${address}`;
        break;
      case BlockchainId.Optimism:
        url = `https://${
          blockchainTestnet ? 'sepolia-' : ''
        }optimistic.etherscan.io/${type}/${address}`;
        break;
      case BlockchainId.Base:
        url = `https://${
          blockchainTestnet ? 'sepolia.' : ''
        }basescan.org/${type}/${address}`;
        break;
      case BlockchainId.Unichain:
        url = `https://unichain${
          blockchainTestnet ? '-sepolia' : ''
        }.blockscout.com/${type}/${address}`;
        break;
      case BlockchainId.Avalanche:
        url = `https://${
          blockchainTestnet ? 'testnet.' : ''
        }snowtrace.io/${type}/${address}`;
        break;
      default:
        throw new Error(`Unsupported blockchain: ${blockchain}`);
    }

    return this._sanitizer.bypassSecurityTrustUrl(url);
  }
}
